export const MOCK_WALLET_BALANCE = 1240.75;

export interface MockPaymentMethod {
  id: string;
  brand: string;
  last4: string;
  expMonth: number;
  expYear: number;
}

export const MOCK_PAYMENT_METHODS: MockPaymentMethod[] = [
  { id: 'pm_1', brand: 'Visa', last4: '4242', expMonth: 9, expYear: 2027 },
  { id: 'pm_2', brand: 'Mastercard', last4: '5599', expMonth: 3, expYear: 2026 }
];

export type LeadKind = 'buyer' | 'lease';

export interface MockLead {
  id: string;
  kind: LeadKind;
  market: string;
  status: string;
  orderedAt: string;
}

export const MOCK_LEADS: MockLead[] = [
  {
    id: 'ld_1',
    kind: 'buyer',
    market: 'Calgary NW',
    status: 'Fulfilled',
    orderedAt: '2026-04-28'
  },
  {
    id: 'ld_2',
    kind: 'lease',
    market: 'Edmonton core',
    status: 'In progress',
    orderedAt: '2026-05-01'
  },
  {
    id: 'ld_3',
    kind: 'buyer',
    market: 'Toronto GTA',
    status: 'Queued',
    orderedAt: '2026-05-03'
  }
];

export type LedgerEntryType = 'credit' | 'debit';

export interface MockLedgerLine {
  id: string;
  type: LedgerEntryType;
  label: string;
  amount: number;
  at: string;
}

export const MOCK_LEDGER: MockLedgerLine[] = [
  {
    id: 'lg_1',
    type: 'credit',
    label: 'Wallet top-up',
    amount: 500,
    at: '2026-04-15'
  },
  {
    id: 'lg_2',
    type: 'debit',
    label: 'Buyer leads — Calgary NW (10)',
    amount: 180,
    at: '2026-04-28'
  },
  {
    id: 'lg_3',
    type: 'debit',
    label: 'Lease leads — Edmonton (5)',
    amount: 75,
    at: '2026-05-01'
  },
  {
    id: 'lg_4',
    type: 'credit',
    label: 'Promotional credit',
    amount: 25,
    at: '2026-05-02'
  }
];

/** Plan & pricing (third dashboard card) */
export type MockAccountKind = 'Agent' | 'Team' | 'Brokerage';

export const MOCK_PLAN_SUMMARY = {
  accountType: 'Agent' as MockAccountKind,
  planType: 'Pay-per-lead',
  buyerLeadUsd: 125,
  rentalSeekerLeadUsd: 30
} as const;

/** Summary metrics for dashboard stat cards */
export const MOCK_STAT_CARDS = [
  {
    id: 'balance',
    title: 'Wallet balance',
    value: `$${MOCK_WALLET_BALANCE.toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
    subValue: 'CAD',
    /** Unused — wallet card shows top-up instead of a trend row */
    trendPct: 0,
    comparisonLabel: ''
  }
] as const;

/** Lead feed table rows (reference-style columns) */
export interface MockLeadFeedRow {
  id: string;
  phone: string;
  name: string;
  email: string;
  address: string;
  leadType: LeadKind;
  evaluation: string;
  createdAt: string;
}

export const MOCK_LEAD_FEED: MockLeadFeedRow[] = [
  {
    id: 'lf_1',
    phone: '(403) 555-0142',
    name: 'Alex Morgan',
    email: 'alex.m@email.com',
    address: '1420 4 St NW, Calgary',
    leadType: 'buyer',
    evaluation: 'View details',
    createdAt: '2026-05-02'
  },
  {
    id: 'lf_2',
    phone: '(780) 555-0198',
    name: 'Jordan Lee',
    email: 'j.lee@email.com',
    address: '88 Ave NW, Edmonton',
    leadType: 'lease',
    evaluation: 'View details',
    createdAt: '2026-05-02'
  },
  {
    id: 'lf_3',
    phone: '(416) 555-0167',
    name: 'Sam Rivera',
    email: 's.rivera@email.com',
    address: '220 King St W, Toronto',
    leadType: 'buyer',
    evaluation: 'View details',
    createdAt: '2026-05-01'
  },
  {
    id: 'lf_4',
    phone: '(587) 555-0133',
    name: 'Taylor Brooks',
    email: 't.brooks@email.com',
    address: 'Mission Rd SW, Calgary',
    leadType: 'buyer',
    evaluation: 'View details',
    createdAt: '2026-05-01'
  },
  {
    id: 'lf_5',
    phone: '(403) 555-0177',
    name: 'Riley Chen',
    email: 'r.chen@email.com',
    address: 'Beltline, Calgary',
    leadType: 'lease',
    evaluation: 'View details',
    createdAt: '2026-04-30'
  },
  {
    id: 'lf_6',
    phone: '(905) 555-0120',
    name: 'Casey Nguyen',
    email: 'c.nguyen@email.com',
    address: 'Mississauga, ON',
    leadType: 'buyer',
    evaluation: 'View details',
    createdAt: '2026-04-30'
  },
  {
    id: 'lf_7',
    phone: '(250) 555-0189',
    name: 'Jamie Patel',
    email: 'j.patel@email.com',
    address: 'Kelowna, BC',
    leadType: 'lease',
    evaluation: 'View details',
    createdAt: '2026-04-29'
  },
  {
    id: 'lf_8',
    phone: '(604) 555-0155',
    name: 'Morgan Blake',
    email: 'm.blake@email.com',
    address: 'Vancouver, BC',
    leadType: 'buyer',
    evaluation: 'View details',
    createdAt: '2026-04-29'
  }
];
